var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConventional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56 471.36H849.73V593.3L777.31 545.02L672.09 590.2L565.63 545.02L473.4 631.06L373.75 659.53L329.8 623.01L295.14 570.4L262.33 601.97L189.29 540.69L138.54 548.12L81.6 499.22L7.94 480.65L8.56 471.36Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M704.74 483.19H653.58V619.89H704.74V483.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M653.97 464.72H704.46L704.35 483.71L653.91 493.45L653.96 464.72H653.97Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M662.4 491.86V510.46L696.16 503.18V485.24L662.4 491.86Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M672.79 508.28V559.38L679.19 549.48L685.15 553.75V505.66L672.79 508.29V508.28Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M653.9 619.95L664.94 620.37V682.14L673.43 685.75L674.28 684.26L684.47 684.69L685.53 685.54L692.32 682.57L692.96 681.3L693.57 620.14H704.38V763.48H653.95L653.9 619.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M653.77 620.34H662.44L662.52 682.59L679.14 686.98L696.18 681.2V620.3H704.44V763.61H653.86L653.78 620.34H653.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M653.81 493.45V763.6H704.42V483.66",
    fill: "#131F2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M653.81 493.45V763.6H704.42V483.66",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M662.45 510.36V730.29V510.36Z",
    fill: "#131F2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M662.45 510.36V730.29",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M696.1 503.19V730.01V503.19Z",
    fill: "#131F2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M696.1 503.19V730.01",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M673.18 730.17V721.53H664.86V577.37H662.43",
    fill: "#131F2E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M673.18 730.17V721.53H664.86V577.37H662.43",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M696.09 577.41H693.54V721.54H685.25V729.91",
    fill: "#131F2E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M696.09 577.41H693.54V721.54H685.25V729.91",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M679.36 566.64L684.05 571.33V620.26H685.63V632.57H672.76V620.19H674.41V573.25L679.36 566.65V566.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M673.35 634.6L666 641.13V682.56L673.02 685.56",
    fill: "#131F2E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M673.35 634.6L666 641.13V682.56L673.02 685.56",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M685.21 634.6L692.56 641.13V682.56L685.54 685.56",
    fill: "#131F2E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M685.21 634.6L692.56 641.13V682.56L685.54 685.56",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M673.39 664.99L665.96 667.43L673.39 664.99Z",
    fill: "#131F2E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M673.39 664.99L665.96 667.43",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M685.17 664.99L692.6 667.43L685.17 664.99Z",
    fill: "#131F2E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M685.17 664.99L692.6 667.43",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M664.91 709.53H673.43H664.91Z",
    fill: "#131F2E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M664.91 709.53H673.43",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M684.84 709.53H693.36H684.84Z",
    fill: "#131F2E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M684.84 709.53H693.36",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M685.21 715.01C685.21 718.3 682.54 720.98 679.24 720.98C675.94 720.98 673.27 718.31 673.27 715.01C673.27 711.71 675.94 709.04 679.24 709.04C682.54 709.04 685.21 711.71 685.21 715.01Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M685.25 680.37C685.25 683.66 682.58 686.34 679.28 686.34C675.98 686.34 673.31 683.67 673.31 680.37C673.31 677.07 675.98 674.4 679.28 674.4C682.58 674.4 685.25 677.07 685.25 680.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M653.84 729.61L605.81 735.01L653.84 738.61V729.6V729.61Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M653.84 748.82L605.81 754.22L653.84 757.82V748.81V748.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M704.57 748.82L752.6 754.22L704.57 757.82V748.81V748.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M704.57 729.61L752.6 735.01L704.57 738.61V729.6V729.61Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M653.99 464.53H651.44V467.23H653.99V464.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M673.2 464.53H670.65V467.23H673.2V464.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M687.91 464.53H685.36V467.23H687.91V464.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M707.57 464.53H705.02V467.23H707.57V464.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M707.72 452.23H705.17V454.93H707.72V452.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M688.06 452.23H685.51V454.93H688.06V452.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M673.2 452.08H670.65V454.78H673.2V452.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M654.14 452.38H651.59V455.08H654.14V452.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M662.4 454.63V439.17H696.02V454.93L662.4 454.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M650.31 454.77L650.42 464.51H707.97V454.77H650.31Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M650.25 459.69L708.08 459.8L650.25 459.69Z",
    fill: "#131F2E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M650.25 459.69L708.08 459.8",
    stroke: "#F7F9F9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M724.63 422.46V418.9H728.93V422.46H724.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M697.14 421.32H706.8L708.18 423.76H720.92V422.49H732.81L733.29 424.56H746.72L742.95 431.99H733.4L732.07 433.48H721.51L720.5 432.21H707.76V435.61H697.25L697.14 421.34V421.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M660.06 439.27L697.21 439.32V417.56H660.14L660.06 439.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M668.96 417.48H666.41V420.18H668.96V417.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M664.82 408.99H662.27V411.69H664.82V408.99Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M697.29 408.83H694.74V411.53H697.29V408.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M691.93 417.32H689.38V420.02H691.93V417.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M658.77 411.29V417.82H699.68V411.29H658.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M658.88 414.42H699.64H658.88Z",
    fill: "#131F2E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M658.88 414.42H699.64",
    stroke: "#F7F9F9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M708.13 423.65C708.13 423.65 706.86 427.63 707.92 432.3L708.13 423.65Z",
    fill: "#131F2E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M708.13 423.65C708.13 423.65 706.86 427.63 707.92 432.3",
    stroke: "#F7F9F9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M720.81 423.71C720.81 423.71 719.96 427 720.81 432.36V423.71Z",
    fill: "#131F2E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M720.81 423.71C720.81 423.71 719.96 427 720.81 432.36",
    stroke: "#F7F9F9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M733.33 424.71C733.33 424.71 732.48 428 733.38 431.87L733.33 424.71Z",
    fill: "#131F2E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M733.33 424.71C733.33 424.71 732.48 428 733.38 431.87",
    stroke: "#F7F9F9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M732.33 413.94C732.33 417.02 729.84 419.52 726.77 419.52C723.69 419.52 721.19 417.03 721.19 413.96V413.94C721.19 410.86 723.68 408.36 726.75 408.36C729.83 408.36 732.33 410.85 732.33 413.92V413.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M721.98 416.47L723.41 415.86L721.98 416.47Z",
    fill: "#131F2E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M721.98 416.47L723.41 415.86",
    stroke: "#F7F9F9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M721.29 414.45L722.75 414.37L721.29 414.45Z",
    fill: "#131F2E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M721.29 414.45L722.75 414.37",
    stroke: "#F7F9F9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M721.58 412.14L722.88 412.59L721.58 412.14Z",
    fill: "#131F2E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M721.58 412.14L722.88 412.59",
    stroke: "#F7F9F9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M722.8 410.1L723.78 411.06L722.8 410.1Z",
    fill: "#131F2E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M722.8 410.1L723.78 411.06",
    stroke: "#F7F9F9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M726.72 414.91L723.11 410.65L724.25 409.73L727.66 414.04L726.73 414.91H726.72Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M724.55 408.8L725.11 410.07L724.55 408.8Z",
    fill: "#131F2E"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M724.55 408.8L725.11 410.07",
    stroke: "#F7F9F9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M727.71 413.99C727.71 414.47 727.32 414.87 726.84 414.87C726.36 414.87 725.96 414.48 725.96 414C725.96 413.5 726.35 413.11 726.83 413.11C727.31 413.11 727.71 413.5 727.71 413.98V413.99Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M726.81 408.4L726.78 409.78L726.81 408.4Z",
    fill: "#131F2E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M726.81 408.4L726.78 409.78",
    stroke: "#F7F9F9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M731.65 416.47L730.22 415.86L731.65 416.47Z",
    fill: "#131F2E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M731.65 416.47L730.22 415.86",
    stroke: "#F7F9F9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M732.34 414.45L730.88 414.37L732.34 414.45Z",
    fill: "#131F2E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M732.34 414.45L730.88 414.37",
    stroke: "#F7F9F9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M732.05 412.14L730.75 412.59L732.05 412.14Z",
    fill: "#131F2E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M732.05 412.14L730.75 412.59",
    stroke: "#F7F9F9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M730.83 410.1L729.85 411.06L730.83 410.1Z",
    fill: "#131F2E"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M730.83 410.1L729.85 411.06",
    stroke: "#F7F9F9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M729.08 408.8L728.52 410.07L729.08 408.8Z",
    fill: "#131F2E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M729.08 408.8L728.52 410.07",
    stroke: "#F7F9F9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M732.33 413.94C732.33 417.02 729.84 419.52 726.77 419.52C723.69 419.52 721.19 417.03 721.19 413.96V413.94C721.19 410.86 723.68 408.36 726.75 408.36C729.83 408.36 732.33 410.85 732.33 413.92V413.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M671.35 411.28V391.24H667.86V387.34H687.67V391.36H683.88V411.29H671.35V411.28Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M677.92 387.34V167.45V387.34Z",
    fill: "#131F2E"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M677.92 387.34V167.45",
    stroke: "#F7F9F9",
    strokeWidth: 3
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M123.38 451.48L124.1 383.26C124.27 379.85 127.24 377.88 127.24 377.88C129.55 375.85 137 372.93 137 372.93L299.41 302.38L304.21 303.43L309.16 309.13L309.61 318.44L307.21 385.98L294.6 387.18L207.09 447.07L184.97 451L123.37 451.48H123.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M284.6 467.49H108.63V470.46H284.6V467.49Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M109.27 440.09V425.76L106.34 428.31V440.77L109.27 440.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M349.03 168.79H342.77L342.88 163.91L341.21 163.89C340.87 160.96 340.92 161.58 341.24 159.36H342.84L342.77 157.11L365.38 157.22V168.79H349.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M619.46 119.19H360.41L341.17 156.07L342.66 157.08H631.32L619.46 119.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M360.33 119.21L341.76 154.55L503.93 154.44V119.1L360.33 119.21Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M619.3 119.21H503.83V154.34H630.56L619.31 119.21H619.3Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M662.72 236.19C673.98 217.5 677.28 179.29 678.18 167.22C676.45 124.67 662.34 98.2499 662.34 98.2499C653.41 90.3699 644.63 87.8899 644.63 87.8899L619.34 116.48L619.42 119.86L654.92 230.78C654.92 230.78 656.42 233.78 659.65 235.43C660.85 236.03 662.73 236.18 662.73 236.18L662.72 236.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M630.55 154.55H341.76H630.55Z",
    fill: "#131F2E"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M630.55 154.55H341.76",
    stroke: "#F7F9F9"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M527.6 136.83L531.21 135.66L581.2 435.7L576.95 436.02L527.6 136.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M518.47 180.66L537.68 177.58L538.74 180.98L519 183.85L518.47 180.67V180.66Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M572.91 157.95L573.87 161.56L530.25 168.67L529.83 165.38L572.92 157.95H572.91Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M555.3 405.98L575.89 403.43L575.15 399.29L554.77 402.16L555.3 405.98Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M512.37 169.95L515.29 175.2L494.59 175.25L497.03 169.89L512.37 169.94V169.95Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M489.38 156.92V162.7L496.96 165.66L497.04 169.79L502.14 172.3L507.43 172.26L512.38 169.75L512.3 165.47L520.18 163.07V156.88L489.37 156.92H489.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M508.93 165.65C508.93 167.96 507.06 169.83 504.75 169.83C502.44 169.83 500.57 167.96 500.57 165.65C500.57 163.34 502.44 161.47 504.75 161.47C507.06 161.47 508.93 163.34 508.93 165.65Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 3
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M502.66 172.39L502.71 175.15H506.74V172.23L502.65 172.39H502.66Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M530.94 261.02H535.4V263.04H532.96V266.65H530.94V261.02Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M504.77 177.15L516.25 176.92L560.9 444.32L548.89 444.24L504.76 177.14L504.77 177.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M517.55 176.08L561.72 443.89L559.49 444.21L514.7 174.95L517.55 176.09V176.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M525 329.37L530.84 329.69L530.73 334.89L528.08 334.78V331.7H524.89L525 329.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M547.61 444.84L503.03 177.27L505.39 176.33L550.05 444.38L547.6 444.84H547.61Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M493.26 174.94L491.99 176.43L491.88 178.87H517.09V176.32L515.92 174.83L493.26 174.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M510.55 207.39H477.53L491.64 179.1L505.9 178.87L510.55 207.39Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M501.24 185.97C501.24 186.99 500.42 187.81 499.4 187.81C498.38 187.81 497.56 186.99 497.56 185.97C497.56 184.95 498.38 184.13 499.4 184.13C500.42 184.13 501.24 184.95 501.24 185.97Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M498.47 192.12C498.47 193.14 497.65 193.96 496.63 193.96C495.61 193.96 494.79 193.14 494.79 192.12C494.79 191.1 495.61 190.28 496.63 190.28C497.65 190.28 498.47 191.1 498.47 192.12Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M495.61 198.28C495.61 199.3 494.79 200.12 493.77 200.12C492.75 200.12 491.93 199.3 491.93 198.28C491.93 197.26 492.75 196.44 493.77 196.44C494.79 196.44 495.61 197.26 495.61 198.28Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M492.91 204.35C492.91 205.37 492.09 206.19 491.07 206.19C490.05 206.19 489.23 205.37 489.23 204.35C489.23 203.33 490.05 202.51 491.07 202.51C492.09 202.51 492.91 203.33 492.91 204.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M486.68 198.5C486.68 199.52 485.86 200.34 484.84 200.34C483.82 200.34 483 199.52 483 198.5C483 197.48 483.82 196.66 484.84 196.66C485.86 196.66 486.68 197.48 486.68 198.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M483.68 204.28C483.68 205.3 482.86 206.12 481.84 206.12C480.82 206.12 480 205.3 480 204.28C480 203.26 480.82 202.44 481.84 202.44C482.86 202.44 483.68 203.26 483.68 204.28Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M489.54 192.5C489.54 193.52 488.72 194.34 487.7 194.34C486.68 194.34 485.86 193.52 485.86 192.5C485.86 191.48 486.68 190.66 487.7 190.66C488.72 190.66 489.54 191.48 489.54 192.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M492.54 186.64C492.54 187.66 491.72 188.48 490.7 188.48C489.68 188.48 488.86 187.66 488.86 186.64C488.86 185.62 489.68 184.8 490.7 184.8C491.72 184.8 492.54 185.62 492.54 186.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M492.09 207.24L409.99 389.01L396.11 389.39L477.91 207.32L492.09 207.24Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M411.23 389.12L425.74 444.48H295.38L295.53 389.09L411.23 389.12Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M549.73 470.58L546.97 443.57H284.13V470.53L549.73 470.58Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M284.35 444.25V467.97H549.57L546.87 444.1L284.35 444.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M561.28 443.72L561.39 470.53H549.59L547.23 443.54L561.28 443.73V443.72Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M278.5 453.86V468.08V453.86Z",
    fill: "#131F2E"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M278.5 453.86V468.08",
    stroke: "#F7F9F9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M273.83 453.92V468.35V453.92Z",
    fill: "#131F2E"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M273.83 453.92V468.35",
    stroke: "#F7F9F9"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M184.61 451.08V420.99H199.24V451.23L184.61 451.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M202.24 451L202.19 453.92L109.06 454.18V451H202.25H202.24Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M108.84 458.37H106.29V462.03H103.74V415.06H106.45L106.24 455.18H108.89L108.84 458.36V458.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M103.85 428.13C103.8 428.55 106.88 427.97 106.88 427.97C106.88 427.97 109.59 426.22 110.01 424.2C110.08 423.21 110.9 423.91 110.22 421.23C110.33 420.75 108.84 420.22 108.84 420.22C108.84 420.22 108.63 421.97 106.82 424.46C106.82 424.46 105.07 426.16 102.73 426.58C102.73 426.58 102.3 427.8 103.84 428.12L103.85 428.13Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M103.64 440.23H108.84L108.79 442.57H103.8L103.64 440.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M130.39 411.14H145.51L162.45 450.92L130.07 450.84L130.39 411.13V411.14Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M117.01 447.44L130.6 447.31V450.31H117.01V447.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M133.46 449.14H130.28V451.37H133.46V449.14Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M145.35 447.76H161.48V450.57H145.4L145.35 447.76Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M145.72 448.88H142.54V451.11H145.72V448.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M142.01 445.85H134V449.78H142.01V445.85Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 442.83H135.38V445.48H140.9V442.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M189.26 421.06V446.43H199.17V420.91L189.26 421.06Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M189.43 449.14H186.25V451.37H189.43V449.14Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M201.69 448.88H198.51V451.11H201.69V448.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M197.98 445.85H189.97V449.78H197.98V445.85Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M196.87 442.83H191.35V445.48H196.87V442.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M106.61 446.12L108.94 446.01V451H106.61V446.12Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M109.16 446.12H113.41V450.68H109.06L109.17 446.12H109.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M113.51 446.09L117.01 447.36V450.76H113.24L113.51 446.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M130.43 411.3V385.56L159.25 373.4L159.1 411.52L130.43 411.29V411.3Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M130.35 408.9L158.94 408.52L159.09 411.67L130.27 411.14L130.35 408.89V408.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M188.74 423.57C188.74 436.44 178.31 446.87 165.44 446.87C152.57 446.87 142.14 436.44 142.14 423.57C142.14 410.7 152.57 400.27 165.44 400.27C178.31 400.27 188.74 410.7 188.74 423.57Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M184.91 423.53C184.91 434.27 176.21 442.97 165.47 442.97C154.73 442.97 146.03 434.27 146.03 423.53C146.03 412.79 154.73 404.09 165.47 404.09C176.21 404.09 184.91 412.79 184.91 423.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M167.05 409.16C167.05 410.09 166.29 410.85 165.36 410.85C164.43 410.85 163.67 410.09 163.67 409.16C163.67 408.23 164.43 407.47 165.36 407.47C166.29 407.47 167.05 408.23 167.05 409.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M167.05 437.98C167.05 438.91 166.29 439.67 165.36 439.67C164.43 439.67 163.67 438.91 163.67 437.98C163.67 437.05 164.43 436.29 165.36 436.29C166.29 436.29 167.05 437.05 167.05 437.98Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M152.64 423.57C152.64 424.5 151.88 425.26 150.95 425.26C150.02 425.26 149.26 424.5 149.26 423.57C149.26 422.64 150.02 421.88 150.95 421.88C151.88 421.88 152.64 422.64 152.64 423.57Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M181.68 423.57C181.68 424.5 180.92 425.26 179.99 425.26C179.06 425.26 178.3 424.5 178.3 423.57C178.3 422.64 179.06 421.88 179.99 421.88C180.92 421.88 181.68 422.64 181.68 423.57Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M297.87 334.78L299.78 321.41H302.38L302.96 322.68H315.43L317.18 320.56L331.56 320.61L332.84 322.62L346.1 322.53L346.72 320.21L362.39 320.09V322.53H374.44L374.86 321.42L376.29 321.63L379.21 336.86L379 384.3L302.11 384.19L302.32 352.11L297.86 334.78H297.87Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M123.6 447.32C123.6 447.32 123.45 389.23 124.05 383.53C124.65 380 126.21 377.94 130.65 375.57L298.46 302.77C301.16 302.17 303.41 303.07 303.41 303.07C303.41 303.07 309.41 306.67 309.86 314.33V322.44",
    fill: "#131F2E"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M123.6 447.32C123.6 447.32 123.45 389.23 124.05 383.53C124.65 380 126.21 377.94 130.65 375.57L298.46 302.77C301.16 302.17 303.41 303.07 303.41 303.07C303.41 303.07 309.41 306.67 309.86 314.33V322.44",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M198.53 446.86H206.81L294.37 387.11H296.39",
    fill: "#131F2E"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M198.53 446.86H206.81L294.37 387.11H296.39",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M243.74 453.97C243.74 453.97 261.15 446.97 266.77 433.59L277.81 377.87C278.87 374.68 281.34 370.29 287.82 368.69L296.31 368.58",
    fill: "#131F2E"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M243.74 453.97C243.74 453.97 261.15 446.97 266.77 433.59L277.81 377.87C278.87 374.68 281.34 370.29 287.82 368.69L296.31 368.58",
    stroke: "#F7F9F9",
    strokeWidth: 3
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M284.18 453.92V468.25H108.74V454.19L284.18 453.92Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M202.24 468.25V449.62V468.25Z",
    fill: "#131F2E"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M202.24 468.25V449.62",
    stroke: "#F7F9F9"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M138.14 445.27V457.79V445.27Z",
    fill: "#131F2E"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M138.14 445.27V457.79",
    stroke: "#F7F9F9"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M194.11 445.27V457.79V445.27Z",
    fill: "#131F2E"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M194.11 445.27V457.79",
    stroke: "#F7F9F9"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M296.07 383.92V388.8L383.84 388.69V383.81L296.07 383.92Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M325.99 383.81V388.8V383.81Z",
    fill: "#131F2E"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M325.99 383.81V388.8",
    stroke: "#F7F9F9"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M329.82 381.27H326.74V383.82H329.82V381.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M331.51 383.92L345.84 353.04L362.29 352.83L378.21 383.82L331.51 383.93V383.92Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M343.03 381.27H339.95V383.82H343.03V381.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M350.19 320.13V333.18H359.95V320.23L350.19 320.12V320.13Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M356.24 381.27H353.16V383.82H356.24V381.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M369.44 381.27H366.36V383.82H369.44V381.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M382.65 381.27H379.57V383.82H382.65V381.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M299.8 381.27H296.72V383.82H299.8V381.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M296.49 367.47L296.28 370.34L300.43 372.48L308.75 372.44L320.45 374.48L320.48 365.46L322.6 363.55L326.74 363.44L322.6 363.12L321.98 361.67L320.16 361.63L318.95 363.12H316.76L316.72 365.75L317.71 365.78V370.42L308.79 370.13L306.14 369.07L304.92 367.37L300.2 367.32L296.49 367.48V367.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M300.95 363.22H298.19V366.03H300.95V363.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M300.84 360.62V367.09H304.61V360.77L300.84 360.61V360.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M323.15 347.14C323.15 355.45 316.42 362.19 308.11 362.2C299.8 362.21 293.06 355.47 293.05 347.16V347.14C293.05 338.83 299.78 332.09 308.09 332.08C316.4 332.08 323.14 338.81 323.15 347.12V347.14Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M300.68 366.04H318.03L318.24 361.95L300.89 361.84L300.68 366.03V366.04Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M321.45 347.27C321.45 354.57 315.54 360.49 308.25 360.49C300.95 360.49 295.03 354.58 295.03 347.29V347.27C295.03 339.97 300.94 334.05 308.23 334.05C315.53 334.05 321.45 339.96 321.45 347.25V347.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M320.42 347.25C320.42 353.96 314.99 359.41 308.27 359.41C301.56 359.41 296.11 353.98 296.11 347.26V347.24C296.11 340.53 301.54 335.08 308.26 335.08C314.97 335.08 320.42 340.51 320.42 347.23C320.42 347.23 320.42 347.23 320.42 347.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M319.47 347.22C319.47 353.39 314.48 358.39 308.31 358.4C302.14 358.4 297.14 353.41 297.13 347.24C297.13 341.06 302.12 336.05 308.29 336.05C314.46 336.05 319.46 341.04 319.47 347.21V347.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M317.24 347.2C317.24 352.09 313.28 356.07 308.38 356.07C303.49 356.07 299.51 352.11 299.51 347.21C299.51 342.3 303.47 338.33 308.37 338.33C313.26 338.33 317.24 342.29 317.24 347.19V347.2Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M336.18 347.89C336.18 352.64 332.34 356.49 327.59 356.49C322.84 356.49 318.99 352.65 318.99 347.9C318.99 343.14 322.83 339.29 327.58 339.28C332.33 339.28 336.18 343.12 336.18 347.87V347.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M308.43 326.02L312.94 331.01V332.71H303.33V330.96L308.42 326.02H308.43Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M303.52 330.85L298.66 331.11L297.86 333.07L296.22 332.11L294.42 334.18L293.36 334.34L292.4 333.23L291.23 334.61L287.73 330.95L287.99 329.04L299.77 325.38L302.85 326.28L307.84 326.47L303.51 330.85H303.52Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M345.05 353.78L333.69 353.89L345.05 353.78Z",
    fill: "#131F2E"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M345.05 353.78L333.69 353.89",
    stroke: "#F7F9F9"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M352.16 319.92L352.11 317.9H350.84L352.22 316.41L356.36 316.3L357.85 317.89H356.42V319.93L352.17 319.9L352.16 319.92Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M344.14 342H333.74H344.14Z",
    fill: "#131F2E"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M344.14 342H333.74",
    stroke: "#F7F9F9"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M427.09 318.09L426.79 312.84L431.74 312.24C431.74 312.24 425.39 273.89 425.29 272.61C425.45 271.81 426.23 268.57 428.41 267.24C431.01 266.5 434.53 267.43 434.53 267.43C434.53 267.43 453.51 277.93 462.74 293.92L463.27 306.83H469.72C474.52 316.59 477.98 326.94 477.07 349.31L471.97 349.16L473.92 366.27C465.06 390.44 454.71 397.49 454.71 397.49C453.66 398.54 449.46 398.54 449.46 398.54C447.21 397.79 445.71 395.39 445.71 395.39L439.11 355.01L433.26 355.61C433.26 339.4 427.11 318.09 427.11 318.09H427.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M354.23 364.71L344.04 353.46C341.58 345.76 342.26 348.78 343.28 342.08L348.82 331.81L350.31 331.17L471.2 311.35C471.2 311.35 476.61 320.77 476.93 344.01L354.24 364.71H354.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M344.36 340.62L381.72 336.59L383.95 348.37L348.39 358.35",
    fill: "#131F2E"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M344.36 340.62L381.72 336.59L383.95 348.37L348.39 358.35",
    stroke: "#F7F9F9"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M382.03 335.84L378.53 336.05L380.97 350.06L384.37 349.21L382.04 335.84H382.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M386.39 335.84C379.81 337.43 381.83 348.47 387.98 347.73L407.93 345.29L406.44 333.19L386.38 335.84H386.39Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M391.8 341.63C391.8 343.45 390.33 344.92 388.51 344.92C386.69 344.92 385.22 343.45 385.22 341.63C385.22 339.8 386.69 338.33 388.51 338.33C390.33 338.33 391.8 339.8 391.8 341.62C391.8 341.62 391.8 341.62 391.8 341.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M399.55 340.57C399.55 342.39 398.08 343.86 396.26 343.86C394.44 343.86 392.97 342.39 392.97 340.57C392.97 338.74 394.44 337.27 396.26 337.27C398.08 337.27 399.55 338.74 399.55 340.56V340.57Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M403.69 325.23L411.23 323.11L366.33 189.06L359.96 191.61L403.69 325.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M399.44 318.22L410.16 314.4L422.47 333.4C428.2 348.37 406.66 355.48 401.67 340.72L399.44 318.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M415.94 337.58C415.94 339.4 414.47 340.87 412.65 340.87C410.83 340.87 409.36 339.4 409.36 337.58C409.36 335.75 410.83 334.28 412.65 334.28C414.47 334.28 415.94 335.75 415.94 337.57V337.58Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M418.68 337.58C418.68 340.98 415.93 343.74 412.53 343.75C409.13 343.76 406.37 341 406.36 337.6V337.58C406.36 334.18 409.11 331.42 412.51 331.41C415.91 331.41 418.67 334.16 418.68 337.56V337.58Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M405.65 335.2C405.65 336.23 404.82 337.06 403.79 337.06C402.76 337.06 401.93 336.23 401.93 335.2C401.93 334.17 402.76 333.34 403.79 333.34C404.82 333.34 405.65 334.17 405.65 335.2Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M419.19 330.1C419.19 331.13 418.36 331.96 417.33 331.96C416.3 331.96 415.47 331.13 415.47 330.1C415.47 329.07 416.3 328.24 417.33 328.24C418.36 328.24 419.19 329.07 419.19 330.1Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M417.56 345.79C417.56 346.82 416.73 347.65 415.7 347.65C414.67 347.65 413.84 346.82 413.84 345.79C413.84 344.76 414.67 343.93 415.7 343.93C416.73 343.93 417.56 344.76 417.56 345.79Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M353.48 172.29H348.39L348.92 165.6C349.66 162.63 353.48 163.27 353.48 163.27L353.69 166.88C353.69 166.88 351.88 169 353.48 172.29Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M359.7 170.1L363.67 166.91L359.07 162.03C356.63 160.18 354.05 163.07 354.05 163.07L356.14 166.02C356.14 166.02 358.88 166.54 359.7 170.11V170.1Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M348.6 172.08L358.89 198.93L364.94 206.47L353.48 172.08H348.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M364.14 167.22L372.01 194.88L371.69 204.54L360.23 170.15L364.14 167.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M353.48 171.54L359.74 191.6L364.52 194.47L366.64 188.84L359.63 168.89C357.83 165.49 352.2 164.75 353.47 171.54H353.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M355.71 178.66L362.29 176.43L355.71 178.66Z",
    fill: "#131F2E"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M355.71 178.66L362.29 176.43",
    stroke: "#F7F9F9"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M358.95 188.46L365.69 186.19L358.95 188.46Z",
    fill: "#131F2E"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M358.95 188.46L365.69 186.19",
    stroke: "#F7F9F9"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M342.78 159.17C342.78 159.17 343.76 161.57 346.27 162.55L354.83 162.66L357.04 161.61L363.64 161.72L363.72 157.18",
    fill: "#131F2E"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M342.78 159.17C342.78 159.17 343.76 161.57 346.27 162.55L354.83 162.66L357.04 161.61L363.64 161.72L363.72 157.18",
    stroke: "#F7F9F9"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M346.53 162.55V168.74V162.55Z",
    fill: "#131F2E"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M346.53 162.55V168.74",
    stroke: "#F7F9F9"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M440.75 277.86C440.75 279.85 439.14 281.46 437.15 281.46C435.16 281.46 433.55 279.85 433.55 277.86C433.55 275.87 435.16 274.26 437.15 274.26C439.14 274.26 440.75 275.87 440.75 277.86Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M438.35 278.01C438.35 278.67 437.81 279.21 437.15 279.21C436.49 279.21 435.95 278.67 435.95 278.01C435.95 277.35 436.49 276.81 437.15 276.81C437.81 276.81 438.35 277.35 438.35 278.01Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M459.52 306.23C459.52 308.22 457.91 309.83 455.92 309.83C453.93 309.83 452.32 308.22 452.32 306.23C452.32 304.24 453.93 302.63 455.92 302.63C457.91 302.63 459.52 304.24 459.52 306.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M457.11 306.38C457.11 307.04 456.57 307.58 455.91 307.58C455.25 307.58 454.71 307.04 454.71 306.38C454.71 305.72 455.25 305.18 455.91 305.18C456.57 305.18 457.11 305.72 457.11 306.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M440.15 309.38C440.15 311.37 438.54 312.98 436.55 312.98C434.56 312.98 432.95 311.37 432.95 309.38C432.95 307.39 434.56 305.78 436.55 305.78C438.54 305.78 440.15 307.39 440.15 309.38Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M437.75 309.53C437.75 310.19 437.21 310.73 436.55 310.73C435.89 310.73 435.35 310.19 435.35 309.53C435.35 308.87 435.89 308.33 436.55 308.33C437.21 308.33 437.75 308.87 437.75 309.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M467.17 353.21C467.17 355.2 465.56 356.81 463.57 356.81C461.58 356.81 459.97 355.2 459.97 353.21C459.97 351.22 461.58 349.61 463.57 349.61C465.56 349.61 467.17 351.22 467.17 353.21Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M464.77 353.36C464.77 354.02 464.23 354.56 463.57 354.56C462.91 354.56 462.37 354.02 462.37 353.36C462.37 352.7 462.91 352.16 463.57 352.16C464.23 352.16 464.77 352.7 464.77 353.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M448.11 356.37C448.11 358.36 446.5 359.97 444.51 359.97C442.52 359.97 440.91 358.36 440.91 356.37C440.91 354.38 442.52 352.77 444.51 352.77C446.5 352.77 448.11 354.38 448.11 356.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M445.71 356.52C445.71 357.18 445.17 357.72 444.51 357.72C443.85 357.72 443.31 357.18 443.31 356.52C443.31 355.86 443.85 355.32 444.51 355.32C445.17 355.32 445.71 355.86 445.71 356.52Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M460.27 385.63C460.27 387.62 458.66 389.23 456.67 389.23C454.68 389.23 453.07 387.62 453.07 385.63C453.07 383.64 454.68 382.03 456.67 382.03C458.66 382.03 460.27 383.64 460.27 385.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M457.86 385.78C457.86 386.44 457.32 386.98 456.66 386.98C456 386.98 455.46 386.44 455.46 385.78C455.46 385.12 456 384.58 456.66 384.58C457.32 384.58 457.86 385.12 457.86 385.78Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M464.32 306.68V304.1C464.32 304.1 464.57 303.38 464.92 303.31L468.46 303.23C469.02 303.45 469.24 304.08 469.24 304.08L469.2 306.74L464.32 306.66V306.68Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M465.37 303.16C465.37 303.16 465.19 301.73 465.37 301.58L467.95 301.55C468.13 301.7 468.04 303.14 468.04 303.14H465.37V303.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M431.57 312.11L431.3 309.54C431.3 309.54 430.96 308.85 430.61 308.82L427.09 309.12C426.55 309.39 426.41 310.05 426.41 310.05L426.73 312.69L431.57 312.09V312.11Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M430.09 308.68C430.09 308.68 430.08 307.24 429.88 307.12L427.32 307.43C427.16 307.6 427.45 309.02 427.45 309.02L430.09 308.68Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M431.57 312.11L431.3 309.54C431.3 309.54 430.96 308.85 430.61 308.82L427.09 309.12C426.55 309.39 426.41 310.05 426.41 310.05L426.73 312.69L431.57 312.09V312.11Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M435.59 359.13C435.59 359.13 435.6 360.57 435.8 360.69L438.36 360.38C438.52 360.21 438.23 358.79 438.23 358.79L435.59 359.13Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M434.11 355.7L434.38 358.26C434.38 358.26 434.72 358.95 435.07 358.98L438.59 358.67C439.13 358.4 439.27 357.74 439.27 357.74L438.95 355.1L434.11 355.7Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M473.29 352.78C473.29 352.78 473.15 354.21 473.34 354.35L475.92 354.3C476.09 354.14 475.96 352.7 475.96 352.7L473.3 352.77L473.29 352.78Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M472.18 349.22V351.8C472.18 351.8 472.45 352.52 472.8 352.59L476.34 352.65C476.9 352.43 477.11 351.79 477.11 351.79L477.06 349.13L472.18 349.23V349.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M449.38 348.62L449.91 351.38C450.81 356.11 459.31 355.47 458.47 349.92L458.04 347.22L449.39 348.63L449.38 348.62Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M455.54 350.51C455.54 351.3 454.9 351.94 454.11 351.94C453.32 351.94 452.68 351.3 452.68 350.51C452.68 349.72 453.32 349.08 454.11 349.08C454.9 349.08 455.54 349.72 455.54 350.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M443.68 315.69L443.29 312.91C442.62 308.14 450.87 306 451.86 311.53L452.32 314.23L443.68 315.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M448.89 311.91C448.64 311.16 447.83 310.77 447.08 311.02C446.33 311.27 445.94 312.08 446.19 312.83C446.44 313.58 447.25 313.97 448 313.72C448.74 313.47 449.14 312.65 448.89 311.91Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M378.91 377.68H381.61V374.98L383.56 372.73L383.71 369.28L379.06 368.98L378.91 377.69V377.68Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M383.87 367.47L381.47 367.17L381.62 361.62L384.02 361.77L383.87 367.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M382.67 369.12V367.17V369.12Z",
    fill: "#131F2E"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M382.67 369.12V367.17",
    stroke: "#F7F9F9"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M382.82 361.62L382.97 360.12L382.82 361.62Z",
    fill: "#131F2E"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M382.82 361.62L382.97 360.12",
    stroke: "#F7F9F9"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M111.22 259.08H105.97V314.47H111.22V259.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M98.31 316.11H77V319.86H98.31V316.11Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6 377.13C96.7 384.03 105.41 383.81 107.81 377.28L108.94 372.93",
    fill: "#131F2E"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6 377.13C96.7 384.03 105.41 383.81 107.81 377.28L108.94 372.93",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M81.09 470.34H94.52L94.6 375.93L81.09 375.78V470.34Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7 470.49L91.53 375.93H81.1V470.42L91.71 470.5L91.7 470.49Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.08
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M98.21 372.7H77.12V376.15H98.21V372.7Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M113.77 319.12H63.19V373.31H113.77V319.12Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M111.53 322.57H65.45V369.85H111.53V322.57Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M78.05 361.5C78.05 364.85 75.46 367.56 72.27 367.56C69.08 367.56 66.49 364.85 66.49 361.5C66.49 358.15 69.08 355.44 72.27 355.44C75.46 355.44 78.05 358.15 78.05 361.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M90.06 361.53C90.06 364.89 87.47 367.62 84.28 367.62C81.09 367.62 78.5 364.89 78.5 361.53C78.5 358.17 81.09 355.44 84.28 355.44C87.47 355.44 90.06 358.17 90.06 361.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M102.07 361.48C102.07 364.82 99.48 367.52 96.29 367.52C93.1 367.52 90.51 364.82 90.51 361.48C90.51 358.14 93.1 355.44 96.29 355.44C99.48 355.44 102.07 358.14 102.07 361.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M75.82 361.44C75.82 363.28 74.33 364.76 72.5 364.76C70.67 364.76 69.18 363.27 69.18 361.44C69.18 359.61 70.67 358.12 72.5 358.12C74.33 358.12 75.82 359.61 75.82 361.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M87.83 361.44C87.83 363.28 86.34 364.76 84.51 364.76C82.68 364.76 81.19 363.27 81.19 361.44C81.19 359.61 82.68 358.12 84.51 358.12C86.34 358.12 87.83 359.61 87.83 361.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M99.84 361.44C99.84 363.28 98.35 364.76 96.52 364.76C94.69 364.76 93.2 363.27 93.2 361.44C93.2 359.61 94.69 358.12 96.52 358.12C98.35 358.12 99.84 359.61 99.84 361.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M68.15 326.17H109.58C110.24 326.17 110.78 326.71 110.78 327.37V351.99C110.78 352.65 110.24 353.19 109.58 353.19H68.15C67.49 353.19 66.95 352.65 66.95 351.99V327.37C66.95 326.71 67.49 326.17 68.15 326.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M109.13 329.02H68.9V350.93H109.13V329.02Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M105.22 314.16H112.72C113.38 314.16 113.92 314.7 113.92 315.36V317.76C113.92 318.42 113.38 318.96 112.72 318.96H105.22C104.56 318.96 104.02 318.42 104.02 317.76V315.36C104.02 314.7 104.56 314.16 105.22 314.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M106.72 251.72H111.22C112.55 251.72 113.62 252.8 113.62 254.12V257.27C113.62 258.6 112.54 259.67 111.22 259.67H106.72C105.39 259.67 104.32 258.59 104.32 257.27V254.12C104.32 252.79 105.4 251.72 106.72 251.72Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M104.32 255.17H76.7",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M101.02 240.76V268.98",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M97.12 243.24V266.66",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M93.18 246.28V263.77",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M89.35 249.92V261.44",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M85.75 252.32V257.99",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M81.51 253.52V256.98",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConventional);
export default __webpack_public_path__ + "static/media/conventional.2789cb862c432b9618b874a7b00a7e11.svg";
export { ForwardRef as ReactComponent };